'use strict';

// https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/2021/IsPropertyKey.js
 ** module id = 93
 ** module chunks = 0
 **/